const homeListFields = `
id
slug
cardTitle
cardTitleEn
cardImage {
  url
  isIcon
  alt
  centered
}
cardDescription
cardDescriptionEn
order
cardDate
cardPersons{
  id
  firstName
  lastName
  slug
  birthDate
  deathDate}
type
subType
tags {
  label
}
`
export const home = () => {
  return `query home {
  ressourceHome(isFront: true) {
    focusText
    focusTextEn
    floraText
    floraTextEn
    exhibitionText
    exhibitionTextEn
    focus {
      ${homeListFields}
    }
    actualities {
      ${homeListFields}
    }
    floras {
      ${homeListFields}
    }
      exhibition {
      ${homeListFields}
    }
  }
}`
}
